import * as z from "zod";

const ProductImageSchema_ = z.object({
  url: z.string(),
  altText: z.string().optional(),
});

export const ProductImageSchema: z.ZodType<ProductImage> = ProductImageSchema_;
export interface ProductImage extends z.infer<typeof ProductImageSchema_> {}

const FrontendProductVariantSchema_ = z.object({
  externalId: z.string(),
  price: z.number().optional(),
  attributes: z
    .array(
      z.object({
        name: z.string(),
        value: z.union([z.string(), z.number(), z.boolean()]),
      }),
    )
    .optional(),
  available: z.boolean(),
  /** Units sellable now. Undefined when the catalog source can't report a count. */
  availableQuantity: z.number().optional(),
  images: z.array(ProductImageSchema).optional(),
});

export const FrontendProductVariantSchema: z.ZodType<FrontendProductVariant> =
  FrontendProductVariantSchema_;
export interface FrontendProductVariant extends z.infer<
  typeof FrontendProductVariantSchema_
> {}

const FrontendProductSchema_ = z.object({
  externalId: z.string(),
  name: z.string(),
  description: z.string().optional(),
  tags: z.array(z.string()),
  collections: z.array(z.string()).optional(),
  categoryPath: z.array(z.string()).optional(),
  images: z.array(ProductImageSchema).optional(),
  variants: z.array(FrontendProductVariantSchema),
  score: z.number().optional(),
  available: z.boolean(),
  url: z.string().optional(),
  metafields: z.record(z.string(), z.unknown()).optional(),
});

export const FrontendProductSchema: z.ZodType<FrontendProduct> =
  FrontendProductSchema_;
export interface FrontendProduct extends z.infer<
  typeof FrontendProductSchema_
> {}
